import { render, staticRenderFns } from "./NotificationDropdown.vue?vue&type=template&id=24407d78&scoped=true"
import script from "./NotificationDropdown.vue?vue&type=script&lang=js"
export * from "./NotificationDropdown.vue?vue&type=script&lang=js"
import style0 from "./NotificationDropdown.vue?vue&type=style&index=0&id=24407d78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24407d78",
  null
  
)

export default component.exports